/*
 * @Author: DT
 * @Date: 2023-02-13 11:00:20
 * @LastEditors: DT
 * @LastEditTime: 2023-02-17 14:11:38
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/app/yzg/index.js
 */
export const yzgCategoryList = (r) => require.ensure([], () => r(require("./category/categoryList/categoryList.vue")), "yzgCategoryList");
export const yzgGroup = (r) => require.ensure([], () => r(require("./group/group.vue")), "group");
export const yzgEditGroup = (r) => require.ensure([], () => r(require("./editGroup/editGroup.vue")), "editGroup");
export const yzgCopy = (r) => require.ensure([], () => r(require("./copy/copy.vue")), "copy");

